export const evolution = [
  {
    era: "文本源流",
    period: "明代以前",
    title: "从《水浒传》的配角到《金瓶梅》的主角",
    text:
      "潘金莲最早出现在《水浒传》的武松故事线中，戏份不多却极具冲击力。到了《金瓶梅》，她由一个过场式人物被扩展成贯穿全书的核心，拥有了完整的家世、婚姻与欲望线索。",
  },
  {
    era: "戏曲舞台",
    period: "清末至民国",
    title: "戏曲与说唱中的潘金莲",
    text:
      "在电影普及之前，京剧、评剧、各种地方戏与说唱早已把潘金莲搬上舞台。舞台版本往往更强调唱腔与身段，人物性格也随之在不同剧种里产生差异。",
  },
  {
    era: "早期银幕",
    period: "1930—1960年代",
    title: "从舞台走向胶片",
    text:
      "这一时期的改编多沿用戏曲结构，潘金莲的形象带有明显的舞台表演痕迹，叙事重心仍围绕西门庆、武大郎与武松之间的伦理冲突展开。",
  },
  {
    era: "港台重塑",
    period: "1970—1980年代",
    title: "作者电影与类型片的介入",
    text:
      "1982年李翰祥的《武松》把焦点放到人物心理与命运上，汪萍更凭此角获得金马奖最佳女主角。港台创作开始为潘金莲注入更复杂的动机，而不再只是道德符号。",
  },
  {
    era: "黄金年代",
    period: "1990年代",
    title: "电视剧与商业电影双线并进",
    text:
      "港剧《恨锁金瓶》、商业电影与央视《水浒传》几乎同期出现。电视的长期陪伴让潘金莲进入大众日常讨论，银幕与荧屏共同塑造了观众对这一角色的集体印象。",
  },
  {
    era: "重拍与重读",
    period: "2000年至今",
    title: "重拍、争论与女性视角",
    text:
      "新版《水浒传》等作品不断重拍经典，同时“重读潘金莲”的写作逐渐兴起。人们开始从制度、处境与性别结构的角度理解她，改编也更多在“忠实”与“再创造”之间寻找平衡。",
  },
];